import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AppliancesListStyles";
import ApplianceListDisc from "../components/ApplianceListDisc";
import ApplianceCostDisc from "../components/ApplianceCostDisc";

export default class AppliancesList extends Component {
  render() {
    let currencyUnit = this.props.appliances.currency_unit;
    return (
      <div>
        <h3 className={css(styles.title)}>{this.props.title}</h3>

        <ul className={css(styles.list)}>
          {Object.keys(this.props.appliances).map((appliance, i) => {
            let item = this.props.appliances[appliance];
            return (
              <li className={css(styles.listItem)}>
                {this.props.ordered && (
                  <ApplianceCostDisc
                    path={"parents-home"}
                    order={i + 1}
                    title={item.name}
                    state={item.status.state}
                    key={i}
                    size={"small"}
                    id={item.appliance_type_id}
                    icon={item.icon}
                    isAssistedLiving={true}
                    cost={
                      this.props.type === "most_costly"
                        ? `${item.cost.unit}${item.cost.value}`
                        : [`${item.duration.value} ${item.duration.unit}`]
                    }
                  />
                )}
                {!this.props.ordered && (
                  <ApplianceListDisc
                    path={"parents-home"}
                    order={i + 1}
                    title={item.name}
                    state={item.status.state}
                    key={i}
                    size={"small"}
                    id={item.appliance_type_id}
                    icon={item.icon}
                    isAssistedLiving={true}
                  />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
